import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor'
import PageState from '../../store/state'
import { Prop, Watch } from 'vue-property-decorator'
import { toast } from '@/utils/util'

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class WordPronunciation extends Vue {
  state = new PageState()
  @Prop({default: ''})
  subtitlesText: string
  @Prop({default: () => []})
  rcTTSWordList: Array<any>
  // 多音字列表
  wordList = []
  // 拼音列表
  pinyinList = []
  // 当前文字索引
  curWordIndex = 0
  // 当前拼音索引
  pinyinIndex = 0
  errorTip = ''
  oldSubtitlesText = ''
  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
  }
  mounted() {
    this.getPolyphoneWordList()
  }
  activated() {
    if (this.oldSubtitlesText !== this.subtitlesText) {
      this.getPolyphoneWordList()
    }
  }
  /**
   * 获取多音字
   */
  getPolyphoneWordList() {
    var reg = /[^\u4e00-\u9fa5]/g
    let querWord = this.subtitlesText
    querWord = querWord.replace(reg, '')
    this.$http('getWordList', {
      lang: "zh-cn",
      word: querWord,
    }).then(res => {
      this.errorTip = ''
      if (res.err_code === 0) {
        const data = res.data
        let forMatData = []
        let currentNumberWord = ''
        Array.from(this.subtitlesText).forEach((ele, index) => {
          const wordIndex = data.findIndex(item => item.word === ele)
          if (wordIndex === -1) {
            forMatData[index] = {
              word: ele,
            }
            return 
          }
          for (let i = 0; i < data.length; i++) {
            if (data[i].word == ele) {
              forMatData[index] = data[i]
              forMatData[index].index = index
              return
            }
          }
        })
       
        // defalt
        const _forMatData = []
        forMatData.forEach(item => {
          if (Number.isNaN(Number(item.word)) || item.word.trim() === '') {
            if (currentNumberWord) {
              _forMatData.push({
                word: currentNumberWord
              })
              currentNumberWord = ''
            }
            _forMatData.push(item)
          } else {
            currentNumberWord += item.word
          }
        })
        if (currentNumberWord) {
          _forMatData.push({
            word: currentNumberWord
          })
          currentNumberWord = ''
        }
        this.wordList = JSON.parse(JSON.stringify(_forMatData))
        const index = this.wordList.findIndex(item => item.defalt && item.defalt)
        this.syncPinYin()
        
        if (index !== -1) {
          this.showPinyin(this.wordList[index], index)
        }
      } else if (res.err_code === -1) {
        this.errorTip = '多音字仅能对汉字进行设置，请重新输入查询'
      } else {
        toast(res.err_msg)
      }
    }).finally(() => {
      this.oldSubtitlesText = this.subtitlesText
    })
  }
  /**
   * 同步显示拼音
   */
  syncPinYin() {
    
    this.wordList.forEach((item, index) => {
      if (this.rcTTSWordList.length) {
        const wordInfo = this.rcTTSWordList[index]
        if (wordInfo && wordInfo.word === item.word && wordInfo.pinyin) {
          item.curpinyin = wordInfo.pinyin
        } else {
          item.curpinyin = ''
        }
      } else {
        item.curpinyin = ''
      }

    })
    
  }
  /**
   * 显示搜索的拼音列表
   * @param wordItem
   */
  showPinyin(wordItem, idx) {
    this.pinyinList = [
      ...wordItem.pinyinList,
      ...wordItem.tone,
      ...wordItem.pron
    ]
    this.curWordIndex = idx
    let pinyin = ''
    if (wordItem.curpinyin) {
      pinyin = wordItem.curpinyin
    } else if (this.rcTTSWordList.length) {
      const info = this.rcTTSWordList[idx]
      if (info && info.pinyin) {
        pinyin = info.pinyin
      }
    }
    if (pinyin === '') {
      pinyin = wordItem.defalt
    }
    let index = this.pinyinList.findIndex(item => item === pinyin)
    if (index == -1) {
      index = 0
    }
    this.pinyinIndex = index
  }
  /**
   * 选择文字
   * @param wordInfo
   * @param index 
   */
  selectWord(wordInfo, index) {
    if (!wordInfo.defalt) return
    this.showPinyin(wordInfo, index)
    this.getChangePronunciation()
    this.$nextTick(() => {
      (this.$refs.wordPronRef as any).scrollTo(0, 1000)
    })
  }
  /**
   * 选择发音人
   * @param articulation
   * @param index 
   */
  selectArticulation(articulation, index) {
    this.pinyinIndex = index
    this.wordList[this.curWordIndex].curpinyin = articulation
    this.getChangePronunciation()
  }
  /**
   * 重置发音
   */
  resetArticulation() {
    const defalt = this.wordList[this.curWordIndex].defalt
    const index = this.pinyinList.findIndex(item => item === defalt)
    this.wordList[this.curWordIndex].curpinyin = this.wordList[this.curWordIndex].defalt
    this.pinyinIndex = index === -1 ? 0 : index
    this.getChangePronunciation()
  }
  /**
   * 获取改变发音的数据
   */
  getChangePronunciation() {
    this.wordList.forEach(item => {
      item.text = this.subtitlesText
    })
    this.$bus.$emit(this.$EventBusKey.CHANGE_POLYPHONE, this.wordList)
  }
}